import { getFirstNavigationUrl } from "@/common/helpers/navigation";
import { NavigationItem } from "@/config/navigation/types";

export const getItemPath = (item: NavigationItem): string | undefined => {
  return getFirstNavigationUrl(item);
};
